module.exports = "<div class=\"error-code\">\n  <div>\n    <h1>HTTP 404</h1>\n  </div>\n  <div>\n    <h2>{{'not-found' | translate}}</h2>\n  </div>\n</div>\n"